import styled from "styled-components";
import burgundyX from "../../images/burgundyxbutton.svg";
import media from "../../styles/media";

export const FormWrapper = styled.section`
  background-color: ${(props) => props.theme.offWhite};
  justify-content: center;
  padding: 100px 0 300px 0;
  text-align: center;

  a {
    color: #471816;
    text-decoration: none;
  }
`;

export const TextContainer = styled.div``;

export const FormTitle = styled.h2`
  display: none;

  ${media.desktop`
    display: block;
    font: normal 46px/46px "Saol Display Medium";
    margin-bottom: 30px;
  `}
`;

export const FormTitleSmall = styled.h2`
  font: normal 29px/34px "Saol Display Medium";
  margin-bottom: 14px;
  margin-top: 38px;
  text-align: center;

  ${media.desktop`
    display: none;
  `}

  ${media.desktopLarge`
    display: none;
  `}
`;

export const FormSubtitle = styled.h3`
  font: normal 15px "Saol Text Book";
  letter-spacing: -0.3px;
  text-align: center;
  color: #471816;
  margin: 0 auto;

  ${media.desktop`
    font-size: 16px;
  `}
`;

export const ContactForm = styled.form`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  left: 50%;
  top: 19.5%;
  transform: translate(-50%, 0);
  flex-direction: column;

  ${media.tablet`
    top: 20.5%;
    margin: 5px 0 0 0;
  `}

  ${media.desktopLarge`
    @media (min-height: 700px) {
      top: 21.5%;
    }

    @media (min-height: 1000px) {
      top: 18%;
    }
  `}

  .show-brokerage {
    display: block;
  }

  .hide-brokerage {
    display: none;
  }

  ::placeholder {
    color: #000000;
    opacity: 1;
    font-size: 14px;
    text-align: center;

    ${media.desktop`
      font-size: 15px;
    `}
  }

  .errorMsg {
    font: lighter 14px "Calluna Light";
    color: red;
    text-align: center;
  }
`;

export const FormInputBox = styled.div`
  margin: 0 auto;
  border-bottom: solid 1px black;
  padding: 24px 0 6px 0;

  input[type="email"],
  input[type="text"],
  input::-webkit-input-placeholder {
    border: none;
    background-color: ${(props) => props.theme.offWhite};
    font: lighter 15px "Calluna Light";
    color: black;
    width: 311px;
    margin: 0 auto;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    border-radius: 0;
    -moz-border-radius: 0;
    -webkit-border-radius: 0;
    text-align: center;
    filter: none;

    ${media.tablet`
      width: 580px;
      margin: 0 auto;
    `}

    &:focus {
      outline: none;
    }
  }

  ${media.tablet`
    padding: 44px 0 12px 0;
  `}
`;

export const FieldSet = styled.fieldset`
  position: relative;
  height: 35px;
  margin: 0 auto;
  margin-top: 2px;
  margin-bottom: 7px;
  border: none;

  ${media.tablet`
    margin-bottom: 0;
  `}

  label {
    margin: 10px auto;
  }

  .radio-custom {
    display: none;
    position: absolute;
    opacity: 0;
    background-color: ${(props) => props.theme.offWhite};
    padding: 10px;
    font-family: sans-serif, Arial;
    font-size: 16px;
    border: 2px solid #444;
    border-radius: 4px;
    margin: 0 auto;
  }

  .radio-custom,
  .radio-custom-label {
    display: inline-block;
    vertical-align: middle;
    margin: 5px;
    cursor: pointer;
  }

  .radio-custom-label {
    position: relative;
    font-size: 15px;
  }

  .radio-custom + .radio-custom-label:before {
    display: inline-block;
    width: 20px;
    height: 20px;
    content: "";
    background: ${(props) => props.theme.offWhite};
    border: 1px solid ${(props) => props.theme.oxBlood};
    vertical-align: middle;
    padding: 2px;
    margin-right: 10px;
    text-align: center;
  }

  .radio-custom:checked + .radio-custom-label:before {
    color: #bbb;
    background-image: url(${burgundyX});
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }

  .radio-custom:focus + .radio-custom-label {
    outline: 1px solid transparent;
  }

  .radio-wrapper {
    margin: 0 auto;
  }
`;

export const FirstOption = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  width: 80px;
  margin: 0 auto;
  border-width: 0 !important;
  padding: 0 !important;

  ${media.desktop`
    left: 16px;
    width: 100px;
  `}
`;

export const SecondOption = styled(FirstOption)`
  left: 77px;

  ${media.desktop`
    left: 90px;
    width: 100px;
  `}
`;

export const SubmitWrapper = styled.div`
  text-align: center;
  color: ${(props) => props.theme.offWhite};
  border-width: 0 !important;
  padding: 0 !important;
`;

export const SubmitButton = styled.button`
  background: #000000;
  border: 1px solid black;
  margin: 21px auto;
  padding: 0 22px;
  font: lighter 11px/24px "Calluna Light";
  color: ${(props) => props.theme.offWhite};
  letter-spacing: 0.06em;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${media.tablet`
    display: block;
    font-size: 18px;
    margin: 0 auto;
    padding: 5px 24px;
  `}
`;

export const Required = styled.p`
  font: 10px "Calluna Italic";
  color: black;
  margin-top: 0;

  ${media.desktop`
    margin-top: 24px;
    font-size: 14px;
  `}
`;

export const Legend = styled.legend`
  position: absolute;
  top: 51%;
  transform: translate(0, -50%);
  left: -120px;
  margin: 0 auto;
  letter-spacing: 0.5px;
  font-family: "Calluna Light";

  ${media.desktop`
    left: -120px;
    font-size: 15px;
  `}
`;

export const Brokerage = styled.div`
  font-size: 13px;
  font-family: "Calluna Light";
  margin: 20px 30px 10px 30px;
  border-width: 0;
  margin: 0 auto;

  input {
    border: none;
    overflow: auto;
    outline: none;
    width: 100px;
    margin-left: 10px;
    margin-bottom: 40px;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    background-color: ${(props) => props.theme.offWhite};
    border-bottom: 1px solid black;
    resize: none;

    ${media.tablet`
      width: 150px;
      margin-left: 20px;
    `}
  }

  ${media.desktop`
    margin: 26px 50px 40px 50px;
    font-size: 15px;
  `}
`;

export const ArchitectGroup = styled.div`
  margin: 36px auto;
  text-align: center;
  font: 10px/14px "Calluna Light";
  letter-spacing: 0.3px;
  border: none;

  ${media.desktop`
    margin-top: 43px;
    font-size: 13px;
    letter-spacing: 0.5px;
    line-height: normal;
  `}
`;

export const FormLabel = styled.label`
  display: none;
`;
